export const LOGO_URL =
 "/logo.png";

export const COMPANY = {
  email: " info@pay10x.io",
  phone: "+65 9004 2845",
  company: "Pay10x Pte. Ltd.",
  location: "Singapore",
};

export const NAV = [
  {
    label: "Solutions",
    to: "/solutions",
  },
  {
    label: "Who We Serve",
    to: "/who-we-serve",
  },
  {
    label: "Security",
    to: "/security",
  },
  {
    label: "Developers",
    to: "/developers",
  },
  {
    label: "Partnerships",
    to: "/partnerships",
  },
  {
    label: "About",
    to: "/about",
  },
];

export default {
  LOGO_URL,
  COMPANY,
  NAV,
};

export const CONTACT = {
  email: " info@pay10x.io",
  phone: "+65 9004 2845",
  company: "Pay10x Pte. Ltd.",
  location: "Singapore",
};